<script setup lang="ts">
import { defineProps } from 'vue'

defineProps({
  label: String,
  url: String,
  drawerOpen: {
    type: Boolean,
    default: true,
  },
  externe: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <RouterLink
    v-if="!externe"
    :to="`${url}`"
    class="w-full flex items-center rounded-s-full item-menu-nav-bar"
    :class="{ 'close-bar': !drawerOpen }"
  >
    <slot></slot>
    <p
      class="text-nowrap"
      :class="{
        ' close-bar': !drawerOpen,
      }"
    >
      {{ label }}
    </p>
  </RouterLink>
  <a
    v-else
    :href="url"
    target="_blank"
    class="w-full flex items-center rounded-s-full item-menu-nav-bar"
    :class="{ 'close-bar': !drawerOpen }"
  >
    <slot></slot>
    <p
      class="text-nowrap"
      :class="{
        'close-bar': !drawerOpen,
      }"
    >
      {{ label }}
    </p>
  </a>
</template>
